import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const percentageRule = (s) =>
  s
    .required("Please input a value")
    .test("range", "Value must be between 1 and 100", (val) => {
      const n = parseFloat(val);
      return !isNaN(n) && n >= 1 && n <= 100;
    });

const amountRule = (s) =>
  s
    .required("Please input an amount")
    .test("positive", "Amount must be greater than 0", (val) => {
      const n = parseFloat(String(val ?? "").replace(/,/g, ""));
      return !isNaN(n) && n > 0;
    });

const schema = yup.object({
  pricing_type_id: yup.string().required("Please select a pricing type"),

  increase_percentage: yup.string().when(["$controlPrice", "$adjustmentType"], {
    is: (controlPrice, adjustmentType) =>
      controlPrice === "+" && adjustmentType === "PERCENTAGE",
    then: percentageRule,
    otherwise: (s) => s.notRequired(),
  }),

  decrease_percentage: yup.string().when(["$controlPrice", "$adjustmentType"], {
    is: (controlPrice, adjustmentType) =>
      controlPrice === "-" && adjustmentType === "PERCENTAGE",
    then: percentageRule,
    otherwise: (s) => s.notRequired(),
  }),

  increase_amount: yup.string().when(["$controlPrice", "$adjustmentType"], {
    is: (controlPrice, adjustmentType) =>
      controlPrice === "+" && adjustmentType === "FIXEDAMOUNT",
    then: amountRule,
    otherwise: (s) => s.notRequired(),
  }),

  decrease_amount: yup.string().when(["$controlPrice", "$adjustmentType"], {
    is: (controlPrice, adjustmentType) =>
      controlPrice === "-" && adjustmentType === "FIXEDAMOUNT",
    then: amountRule,
    otherwise: (s) => s.notRequired(),
  }),
});

export const useValidation = ({ productsDetails, controlPrice }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    context: {
      controlPrice,
      adjustmentType: productsDetails?.adjustment_type,
    },
    defaultValues: productsDetails,
  });
};
